import { DialogMemberType } from './memberType';
import { URN } from '#uri';
/**
 * Содержит параметры пользователя как участника диалога.
 * Пользователь может быть участником нескольких диалогов, поэтому нужна вспомогательная сущность которая привязана к пользователю приложения а не участнику диалога.
 * @class
 */
export class MemberUser {
    #urn;
    #type;
    #id;
    /**
     * Creates an instance of `MemberUser`.
     *
     * @param {DialogMemberType} type - The type of the dialog member (e.g., Client, Admin, Bot).
     * @param {number} id - The unique identifier for the user.
     * @throws {Error} When `type` is not provided or invalid.
     * @throws {Error} When `id` is not provided.
     */
    constructor(type, id) {
        if (!type) {
            throw new Error('Invalid member type');
        }
        if (!id) {
            throw new Error('Cant create MemberUser without user ID');
        }
        this.#urn = new URN({ nid: MemberUser.NID, nss: [type, id].join('-') });
        this.#type = type;
        this.#id = id;
    }
    get id() {
        return this.#id;
    }
    get type() {
        return this.#type;
    }
    toString() {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return this.#urn.toString();
    }
    toJSON() {
        return {
            id: this.id,
            type: this.type,
        };
    }
    static create(member) {
        return member.type && member.id ? new MemberUser(member.type, member.id) : null;
    }
    static client(clientId) {
        return new MemberUser(DialogMemberType.Client, clientId);
    }
    static admin(adminId) {
        return new MemberUser(DialogMemberType.Admin, adminId);
    }
    static bot(botId) {
        return new MemberUser(DialogMemberType.Bot, botId);
    }
    static isEqual(a, b) {
        return a.toString() === b.toString();
    }
    static parse(str) {
        const { nid, nss } = new URN(str);
        if (nid !== this.NID) {
            throw new TypeError('Failed to parse MemberUser');
        }
        const [type, id] = nss.split('-').map(Number);
        return new MemberUser(type, id);
    }
    static NID = 'dmuser';
}
//# sourceMappingURL=memberUser.js.map